<template>
  <div>
    <div class="customer-detail">
      <div class="customer-header pt-6 pb-7">
        <slot name="header"></slot>
        <div class="text-xs-center">
          <v-avatar size="100">
            <v-img
              :lazy-src="user.profile_pic"
              :src="user.profile_pic"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template #placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-avatar>
          <div class="text-xs-center mt-2" style="color: white">
            {{ user.status ? user.status : '' }}
          </div>
          <div class="mb-4 text-xs-center">
            <v-btn
              v-if="user.app == 'facebook' && user.inboxurl"
              :href="'https://business.facebook.com/latest/' + user.userid"
              target="_blank"
              small
              depressed
              round
              color="#3b5998"
              dark
            >
              <em class="fab fa-facebook-square mr-1" />
              {{ $t('View inbox') }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div pa-2 class="pa-3 px-3">
      <v-layout row wrap>
        <v-flex xs12>
          <label class="caption">Name</label>
          <p style="font-weight: bold">{{ sessionvalue.name }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Givenname</label>
          <p style="font-weight: bold">{{ sessionvalue.givenName }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Middlename</label>
          <p style="font-weight: bold">{{ sessionvalue.middleName }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Surname</label>
          <p style="font-weight: bold">{{ sessionvalue.sn }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Displayname</label>
          <p style="font-weight: bold">{{ sessionvalue.displayName }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Description</label>
          <p style="font-weight: bold">{{ sessionvalue.description | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Physical Delivery OfficeName</label>
          <p style="font-weight: bold">{{ sessionvalue.physicalDeliveryOfficeName | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Mail</label>
          <p style="font-weight: bold">{{ sessionvalue.mail | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">sAMAcountName</label>
          <p style="font-weight: bold">{{ sessionvalue.sAMAcountName | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Title</label>
          <p style="font-weight: bold">{{ sessionvalue.title | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Department</label>
          <p style="font-weight: bold">{{ sessionvalue.department | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Company</label>
          <p style="font-weight: bold">{{ sessionvalue.company | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Manager</label>
          <p style="font-weight: bold">{{ sessionvalue.manager | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">PostOfficeBox</label>
          <p style="font-weight: bold">{{ sessionvalue.postOfficeBox | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Pager</label>
          <p style="font-weight: bold">{{ sessionvalue.pager | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Member Of</label>
          <p style="font-weight: bold">{{ sessionvalue.memberOf | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">User Principal Name</label>
          <p style="font-weight: bold">{{ sessionvalue.userPrincipalName | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">SCG Cost Center</label>
          <p style="font-weight: bold">{{ sessionvalue.SCGCostCenter | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">SCGCom CodeBilling</label>
          <p style="font-weight: bold">{{ sessionvalue.SCGComCodeBilling | isExist }}</p>
        </v-flex>
        <v-flex xs6>
          <label class="caption">Employee Type</label>
          <p style="font-weight: bold">{{ sessionvalue.employeeType | isExist }}</p>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      default: undefined
    },
    pageid: {
      default: undefined
    }
  },

  data() {
    return {
      user: {},
      sessionvalue: {},
      loading: false,
      currentpageid: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    var vm = this
    if (this.pageid) {
      this.currentpageid = this.pageid
    } else {
      this.currentpageid = this.selectedBot.pageid
    }
    vm.getUser(vm.value).then(
      function (user) {
        if (user) {
          vm.user = user
          try {
            vm.sessionvalue = JSON.parse(user.sessionvalue)
          } catch (error) {}
        }
        vm.loading = false
      },
      function (error) {
        vm.loading = false
      }
    )
  },
  methods: {
    getUser: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.currentpageid
        }

        api.getUserOnly(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    }
  },
  filters: {
    isExist: function (value) {
      return value ? value : '-'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/scgworkplace-customer.vue